"use client";

import { useTranslations } from "next-intl";
import React from "react";

import OptimizedImage from "../common/images/OptimizedImage";
import { Link } from "@/i18n/routing";
import { formatImageUrl } from "@/lib/utils";
import { truncateText } from "@/utils/utils";

interface TeamCardProps {
  agent: any;
}

const TeamCard: React.FC<TeamCardProps> = ({ agent }) => {
  let agentPhoto = agent.user?.photo;
  const maxCharLength = 100;
  const t = useTranslations("OurTeam.card");

  if (typeof agentPhoto !== "string") {
    agentPhoto = agentPhoto.src;
  } else {
    agentPhoto = formatImageUrl(agentPhoto);
  }

  return (
    <Link
      key={agent.id}
      href={`/our-team/${agent.slug ?? agent.id}`}
      className="flex h-full cursor-pointer rounded-2xl bg-white transition-transform"
      tabIndex={0}
      aria-label={`View ${agent.user?.name || "Agent"}'s profile`}
    >
      <div className="flex w-full flex-col rounded-[2rem] bg-white p-1">
        <div className="relative h-80 flex-shrink-0">
          <OptimizedImage
            width={375}
            maxWidth={500}
            sizes="(max-width: 768px) 100vw, 375px"
            imageLayout="custom"
            src={agentPhoto ?? (agent.image || "/assets/images/default-agent.svg")}
            alt={`${agent.user?.name ?? agent.name}-photo`}
            className="rounded-t-2xl object-contain object-top p-2"
          />
        </div>

        <div className="flex flex-1 flex-col px-4 py-2">
          <div className="mb-2">
            <h3 className="urbanist text-2xl font-bold text-primary-foreground">{agent.user?.name || "Agent"}</h3>
            {agent?.designation && <p className="inter text-sm font-normal text-black">{agent.designation}</p>}
          </div>

          {/* {agent.languages ? (
            <div className="flex items-center gap-3 border-t border-gray-200 py-2">
              <Globe className="mt-0.5 h-4 w-4 flex-shrink-0 text-gray-500" aria-hidden="true" />
              <div className="flex flex-col gap-1">
                <span className="inter text-xs font-normal text-[#292D3480]">{t("language")}</span>
                <span className="inter text-sm font-medium text-primary-foreground">
                  {formatLanguages(agent.languages)}
                </span>
              </div>
            </div>
          ) : null} */}
          {agent.agentShortIntro && (
            <div className="inter mb-4 border-t border-gray-200 pt-4 text-left rtl:text-right">
              <p className="text-sm font-normal text-[#4D4D4D]">{truncateText(agent.agentShortIntro)}</p>
              {agent.agentShortIntro.length > maxCharLength && (
                <span className="my-2 inline-block text-sm font-medium text-primary hover:text-primary/80">
                  View Profile
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    </Link>
  );
};

export default TeamCard;
